{
    "status": {
        "due": "À faire",
        "overdue": "En retard",
        "completed": "Terminé"
    },
    "blankAnswer": "Non renseigné",
    "list": {
        "title": "Journaux",
        "emptyTitle": "Aucun journal pour le moment",
        "emptyDescription": "Les journaux créés pour vous apparaîtront ici",
        "checkAgain": "Vérifier à nouveau",
        "needsAttention": "Nécessite votre attention",
        "needsAttentionDesc": "Journaux dont les formulaires attendent votre prochaine saisie.",
        "upToDate": "À jour",
        "ongoing": "En cours",
        "ongoingDesc": "Journaux en cours ou en attente de votre première saisie.",
        "upToDateDesc": "Journaux en cours sans saisie à effectuer.",
        "noOngoing": "Aucun journal en cours pour le moment",
        "completed": "Terminés",
        "completedDesc": "Journaux clôturés (plus aucune saisie n'est enregistrée).",
        "noCompleted": "Aucun journal terminé pour le moment",
        "openDiary": "Ouvrir le journal",
        "reviewDiary": "Consulter le journal"
    },
    "goToDiaries": {
        "title": "Aller à {{diaryWord}}",
        "actionRequiredCount": "Action requise ({{count}})",
        "actionRequiredOneForm": "Action requise ({{count}} formulaire)",
        "actionRequiredManyForms": "Action requise ({{count}} formulaires)",
        "defaultDescription": "Les journaux sont vos suivis de santé personnels et aident à améliorer les traitements et la recherche.",
        "oneFormDue": "Vous avez {{count}} formulaire à remplir.",
        "manyFormsDue": "Vous avez {{count}} formulaires à remplir.",
        "diariesNeedAttention": "Vous avez {{count}} {{diaryWord}} dont les formulaires nécessitent votre attention."
    }
}
